import React, { useEffect, useState } from "react";
import { Box, Button, Divider, Flex, Grid, GridItem, Image, Text } from "@chakra-ui/react";
import heroImg from "../Assets/Images/student-hero-bg.png";
import CustomTable from "../components/CustomTable";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GoArrowRight } from "react-icons/go";
import { FaBookOpen } from "react-icons/fa";
import { MdKeyboardArrowRight } from "react-icons/md";
import StudentDashboardEventCard from "../components/StudentDashboardEventCard";
import StudentDashboardExamResult from "../components/StudentDashboardExamResult";
import { fetchStudentDashboard } from "../redux/slices/dashboardSlice";
import { fetchMemberDues } from "../redux/slices/membershipManagementSlice";
import { clearsearchFilter } from "../redux/slices/searchFilterSlice";


const StudentDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const studentDashboardData = useSelector(
    (state) => state?.dashboard?.studentDashboard
  );

  const [showAll, setShowAll] = useState(false);
  const sortedEvents = studentDashboardData?.events
  ? [...studentDashboardData?.events].sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
  : [];
  const displayedEvents = showAll ? sortedEvents : sortedEvents.slice(0, 4);
  const backColors = ["#EFE6F6", "#FFF6EC", "#EDF2FB", "#FFECF0"];
  const bordersColors = ["#E1D2FF", "#FDE1AC", "#BAE5F5", "#CCEFBF"];
  const progressColors = ["#FD6C75",  "#812773"];

  useEffect(() => {
    dispatch(fetchMemberDues());
    dispatch(clearsearchFilter());
  }, [dispatch]);

  const handleMakePayment = (item) => {
    navigate("/mydues/paymentdetails");
  };


console.log('student data', studentDashboardData)
  useEffect(() => {
    dispatch(fetchStudentDashboard());
  }, [dispatch]);

  const member = useSelector((state) => state.auth?.memberProfile);
  const duesData = useSelector((state) => state?.membershipManagement);
  const tableProps = {
    data: duesData?.memberDues,
    title: {
      feeName: "Fee Name",
      year: "Fee Year",
      amountOwed: " Amount Owed",
    },
    dataKeys: ["feeName", "year", "amountOwed"],
    sn: false,
    showPagination: false,
    transformRow: (item) => ({
      feeName: <Box style={{ cursor: "pointer" }}>{item?.name}</Box>,
      year: <Box style={{ cursor: "pointer" }}>{item?.year}</Box>,
      amountOwed: <Box style={{ cursor: "pointer" }}>{item?.amountOwed}</Box>,
    }),
  };
  return (
    <Flex
      flexDirection={"column"}
      gap={"20px"}
      py={"30px"}
      minH={"100vh"}
      px={3}
    >
      <Text color={"#D73439"} fontWeight={"400"} fontSize={"16px"} lineHeight={"100%"} fontFamily={"popins"}>
      👋 Welcome {member?.firstName + " " + member?.lastName} 
      </Text>
      <Flex gap={5} flexDirection={["column","column", "row", "row"]} alignItems={"center"}>
        <Box height={['450px', '260px', '260px']} borderRadius={"4px"} bgColor={"#F6E9EA"} border={"1px solid #D11A2A33"} fontFamily={"popins"}>
          <Flex
            px={10}
            py={6}
            flexDirection={["column", "row", "row"]}
            justifyContent={["center", "space-between", "space-between"]}
            alignItems={"center"}
            gap={"20px"}
          >
            <Flex
              flexDirection={"column"}
              fontFamily={"inter"}
              gap={3}
              color={"#FFFFFF"}
              letterSpacing={"-0.15px"}
            >
              <Text color={"#0C1E33"} fontWeight={"600"} fontSize={"16px"} lineHeight={"100%"}>
                Current Grade: {member?.memberCategory}
              </Text>
              <Text
                mt={4}
                fontWeight={"400"}
                fontSize={"12px"}
                lineHeight={"100%"}
                color={"#495D72"}
              >
              Welcome to the platform. Kindly click on the button below to make payment when you have any outstanding dues.
              </Text>
              <Button
                rightIcon={<GoArrowRight style={{width: "20px", height: "20px"}} />}
                mt={3}
                w={"147px"}
                borderRadius={"4px"}
                bgColor={"#D11A2A"}
                color={"#FFFFFF"}
                fontWeight={"500"}
                fontSize={"12px"}
                lineHeight={"100%"}
                _hover={{ bgColor: "" }}
                _active={{ bgColor: "" }}
                onClick={(item) => handleMakePayment(item)}
              >
                Make Payment
              </Button>
            </Flex>
            <Image
              src={heroImg}
              alt="Student Hero Image"
              h={"230px"}
              w={"250px"}
            />
          </Flex>
        </Box>
        <Box height={'260px'} width={["100%", "100%", "50%","50%", "30%"]} borderRadius={"4px"} bgGradient="linear(to-b, #D73439, #BA68C8)">
          <Flex flexDirection={"column"} alignItems={"center"} gap={5} px={10} py={10} color={"#FFFFFF"} fontFamily={"inter"}>
            <Text fontWeight={"600"} fontSize={"24px"} lineHeight={"100%"} >Member Upgrade</Text>
            <Text textAlign={"center"} fontWeight={"500"} fontSize={"14px"} lineHeight={"20px"}>Upgrade your current level to a higher one here</Text>
            <Button
                mt={3}
                w={"147px"}
                fontFamily={'inter'}
                borderRadius={"12px"}
                bgColor={"#FFFFFF"}
                color={"#2E2E2E"}
                fontWeight={"500"}
                fontSize={"14px"}
                lineHeight={"100%"}
                _hover={{ bgColor: "" }}
                _active={{ bgColor: "" }}
              >
                Upgrade Now
              </Button>
          </Flex>
        </Box>
      </Flex>
      <Box mt={3}>
        <Flex flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} gap={'20px'} px={'20px'} mb={2}>
          <Flex gap={2} alignItems={'center'}>
            <FaBookOpen style={{width: "20px", height: "20px", color:'#0C1E33'}} />
            <Text fontSize={'14px'} fontWeight={'500'} color={'#0C1E33'} fontFamily={'popins'} >UPCOMING EVENTS</Text>
          </Flex>
          <Flex gap={1} color={'#2F80ED'} alignItems={'center'} onClick={() => setShowAll(!showAll)} cursor={'pointer'}>
            <Text fontSize={'12px'} fontWeight={'500'} fontFamily={'popins'} lineHeight={'100%'}
            >
              {showAll ? "View Less" : "View all"}
            </Text>
            <MdKeyboardArrowRight />
          </Flex>
        </Flex> 
        <Divider border={'1px solid #CED8E5'} />
        <Grid mt={5} gridTemplateColumns={['repeat(1, 1fr)', 'repeat(2, 1fr)', 'repeat(3, 1fr)', 'repeat(4, 1fr)']} gap={6}>
          {displayedEvents?.map((item, index) => {
            const bgColor = backColors[index % backColors.length];
            const borderColor = bordersColors[index % bordersColors.length];
            return (
              <GridItem key={item?.id}>
                <StudentDashboardEventCard 
                  eventName={item?.eventName}
                  eventAttendees={item?.attendees}
                  eventDate={item?.startDate}
                  eventTime={item?.time}
                  eventLocation={item?.location}
                  bagColor={bgColor}
                  bordersColor={borderColor}
                />
              </GridItem>
            );
          })}
        </Grid>

      </Box>
      <Flex
        flexDirection={["column","column", "row", "row"]}
        alignItems={"center"}
        gap={"20px"}
        my={3}
      >
        <Flex
          flexDirection={"column"} border={'1px solid #D11A2A33'}
          w={["100%","100%", "60%", "60%"]}
          bg={"#FFFFFF"}
          borderRadius={"4px"}
          p={5}
          gap={4}
          h={"350px"}
          sx={{
            overflowY: "scroll",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "-ms-overflow-style": "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
          overflowY={"auto"}
        >
          <Text
            fontWeight={"500"}
            fontSize={"14px"}
            lineHeight={"100%"}
            color={"#D73439"}
          >
            {" "}
            MY DUES
          </Text>
          <CustomTable {...tableProps} />
        </Flex>
        <Flex flexDirection={"column"} border={'1px solid #D11A2A33'}
          w={["100%","100%", "40%", "40%"]}
          bg={"#FFFFFF"}
          borderRadius={"4px"}
          p={5}
          gap={4}
          h={"350px"}
          sx={{
            overflowY: "scroll",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "-ms-overflow-style": "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
          overflowY={"auto"}>
          <Text
            fontWeight={"500"}
            fontSize={"14px"}
            lineHeight={"100%"}
            color={"#D73439"}
          >
            {" "}
            LATEST EXAM RESULTS
          </Text>
          <Box my={5}>
          {
            studentDashboardData?.StudentExamResult?.map((item, index) => {
              const colorArray = progressColors[index % progressColors.length];
              return (
                <StudentDashboardExamResult key={item?.id}
                  subject={item?.subject}
                  unit={item?.grade}
                  score={item?.score}
                  colors={colorArray}
                />
              );
            })
          }
          </Box>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default StudentDashboard;
